import { DataSource } from '@angular/cdk/table';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material';
import { CustomerResponseInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { Observable } from 'rxjs';

import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';

@Component({
  selector: 'ca-customers-page',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  public customers: CustomersDataSource;
  public loading$: Observable<boolean>;
  public page$: Observable<PageEvent>;
  public filter$: Observable<any>;
  public admin$: Observable<boolean>;

  _search: string = '';
  set search(value: string) {
    this._search = value;
    this.updateSearch(this._search);
  }
  get search() {
    return this._search;
  }

  public tableConfig = [
    {
      key: 'lastName',
      sortable: true,
      title: 'Surname',
      render: row => (row ? row.lastName : '')
    },
    {
      key: 'firstName',
      sortable: true,
      title: 'Given Name(s)',
      render: row => (row ? row.firstName : '')
    },
    {
      key: 'dateOfBirth',
      sortable: true,
      title: 'Date of Birth',
      render: row => (row && row.dateOfBirth ? moment(row.dateOfBirth).format('DD/MM/YYYY') : '')
    },
    {
      key: 'address',
      title: 'Address',
      sortable: false,
      render: row => {
        const address = (row && row.address) || {};
        return `${address.address1}, ${address.address2 || ''} ${address.town} ${address.state} ${
          address.postcode
        }`;
      }
    }
  ];

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.loading$ = this.store.select(selectors.getLoadingAll(selectors.CUSTOMERS));
    this.store.dispatch(actions.Customers.UpdateFilterAction({}));
    this.store.dispatch(actions.Customers.RequestPageAction());
    this.customers = new CustomersDataSource(
      this.store.select(selectors.getAll(selectors.CUSTOMERS))
    );
    this.page$ = this.store.select(selectors.getPageination(selectors.CUSTOMERS));
    this.filter$ = this.store.select(selectors.getFilter(selectors.CUSTOMERS));
    this.admin$ = this.store.select(selectors.auth.isAdmin);
  }

  paginate(event) {
    this.store.dispatch(actions.Customers.PageChangeAction(event));
  }

  updateSearch(search: string) {
    if (search.length > 0) {
      this.store.dispatch(
        actions.Customers.UpdateFilterAction({
          where: {
            or: [{ firstName: { ilike: `${search}%` } }, { lastName: { ilike: `${search}%` } }]
          }
        })
      );
    } else {
      this.store.dispatch(actions.Customers.UpdateFilterAction({}));
    }
  }

  sort(event) {
    if (event.direction) {
      this.store.dispatch(
        actions.Customers.UpdateFilterAction({
          order: `${event.active} ${event.direction.toUpperCase()}`
        })
      );
    }
  }
}

export class CustomersDataSource extends DataSource<CustomerResponseInterface> {
  constructor(public data: Observable<CustomerResponseInterface[]>) {
    super();
  }

  connect() {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
